import React, { useEffect, useState } from "react";
import { Getdata } from "../../helpers/api.service";
import { useNavigate } from "react-router-dom";

const Facilities = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/education/facility/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 max-w-6xl gap-3">
        {data.length > 0 &&
          data.map((item, index) => (
            <div className="border-[#EAEAEA] bg-[#F9F5FF] border-[2px] rounded-lg " key={index}>
              <img
                className="w-full h-[200px] sm:h-[230px] object-cover cursor-pointer"
                onClick={() =>
                  navigate(`/education/facilities/view/${item.name}`)
                }
                alt={item.name}
                src={item.image[0]}
              />
              <div className=" relative flex justify-between text-gray-800 mb-2  mx-auto">
                <div>
                  <h3 className="text-sm font-semibold p-[10px] ml-2">
                    {item.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
      </div>
      {data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default Facilities;
